import UniUtils, { UniRouteType } from "@/utils/uni";
import JSBridge from "./jsbridge";
import { isAbsoluteWebUrl, resolveProjectNavigationUrl } from "./navigation";

const localSwRouter = function(url, type = "push") {
  if (typeof url === "object" && url !== null) {
    url = dealUrl(url);
  }

  url = resolveProjectNavigationUrl(url);

  if (window.mobileRuntime.isApp) {
    JSBridge.callHandler("onNormalizingCall", {
      type: 6,
      url: typeof url === "string" && url.includes("#") ? url : `#${url}`,
    });
    if (type === "replace") JSBridge.callHandler("closePage");
    return;
  }

  if (window.mobileRuntime.isMiniProgram) {
    const routeType = type === "replace" ? UniRouteType.redirectTo : UniRouteType.navigateTo;
    const targetUrl = typeof url === "string" && url.includes("#") ? url : `#${url}`;
    UniUtils.webviewRouter(targetUrl, routeType);
    return;
  }

  if (isAbsoluteWebUrl(url)) {
    type === "replace" ? window.location.replace(url) : window.location.assign(url);
    return;
  }

  if (typeof url === "string" && url.includes("#")) {
    window.location.href = `${window.location.origin}${url}`;
    return;
  }

  if (type === "replace") this.$router.replace(url);
  else this.$router.push(url);
};

function dealUrl(url) {
  const params = [];
  const path = url.path || url.name || "/";
  const query = url.query || {};

  Object.keys(query).forEach(key => {
    const value = query[key];
    if (Array.isArray(value)) {
      value.forEach(item => params.push(`${key}=${item}`));
    } else if (typeof value === "object" && value !== null) {
      params.push(`${key}=${encodeURIComponent(JSON.stringify(value))}`);
    } else {
      params.push(`${key}=${value}`);
    }
  });

  return params.length ? `${path}?${params.join("&")}` : path;
}

export default localSwRouter;
